import MakeModelChatQuestionType from '@/enums/MakeModelChatQuestionType';
import MakeModelChatType from '@/enums/MakeModelChatType';

export interface ChatMessageOptions {
    text?: string;
    questionInsight?: string;
    choices?: string[];
    imageURL?: string;
    makeModelChatQuestionType?: MakeModelChatQuestionType;
    helpOptions?: helpOptions;
    bypassConfirmation?: boolean;
}

interface helpOptions {
    helpButton?: boolean;
    helpRequested?: boolean;
}

export default class ChatMessage {
    public type: MakeModelChatType;

    public options: ChatMessageOptions;

    public isFinished: boolean = false;

    constructor(type: MakeModelChatType, options: ChatMessageOptions = {}) {
        this.type = type;
        this.options = options;
    }
}
